import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function indentBlock(value, spaces = 2) {
  const prefix = ' '.repeat(spaces)
  return value
    .split('\n')
    .map((line) => `${prefix}${line}`)
    .join('\n')
}

export function getHostHeaderFromOrigin(origin) {
  try {
    return new URL(origin).host
  } catch {
    return origin.replace(/^https?:\/\//, '')
  }
}

export function hexToRgbStr(hex) {
  hex = hex.replace('#', '')
  if (hex.length === 3)
    hex = hex
      .split('')
      .map((c) => c + c)
      .join('')
  const n = Number.parseInt(hex, 16)
  return `${(n >> 16) & 255},${(n >> 8) & 255},${n & 255}`
}

export const normalizeQuery = (q: string) => {
  return q
    .toLowerCase()
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 2) // remove noise
    .slice(0, 4) // keep top keywords
    .join(' ')
}
